import React, { useRef, useState, useEffect } from "react";
import CssTransition from "../../../../component/layout/css-transition";
import { StyledDropZone } from "react-drop-zone";
import "react-drop-zone/dist/styles.css";
import template from "../../../../assets/template/template.xlsx";
import ImageDataModal from "./ImageDataModal";
import { useDispatch, useSelector } from "react-redux";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../../component/modal-popup/customeModal";
import * as XLSX from "xlsx";
import { createMultipleUser } from "../../../../redux/actions/user";

export default function BulkCreateValidation({
  modalOpen,
  setModalOpen,
  update,
  setUpdate,
}) {
  const modalContent = useRef(null);
  const [img, setImg] = useState(false);
  const [alldata, setAllData] = useState([]);

  // Redux 
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);

  // Function to extract data from excel
  function importData(file) {
    let f = file;
    const reader = new FileReader();
    reader.onload = (evt) => {
      // evt = on_file_select event
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      var data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      data = data.split("\n");
      const arr = [];
      data.map((ele, index) => {
        if (index != 0) {
          const [
            firstname,
            lastname,
            email,
            mobile,
            company,
            team,
            location,
            type,
          ] = ele.split(",");
          const obj = {
            name: firstname + " " + lastname,
            first_name: firstname,
            last_name: lastname,
            email: email,
            password: "",
            role: "user",
            company_id: user.company.id,
            mobile: mobile,
            companyname: company,
            department: team,
            location: location,
            type: type,
            created_by: user.id,
          };
          arr.push(obj);
        }
      });
      setAllData(arr);
    };
    reader.readAsBinaryString(f);
  }

  // Function to call API of add Users for excel file
  const NewhandleAddUsers = () => {
    const request = {
      payload: alldata,
      onSuccess: () => {
        setUpdate(update + 1);
        setModalOpen(false)
      },
      onError: (error) => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    }

    dispatch(createMultipleUser(request))
  }

  useEffect(() => {
   if(alldata.length > 0) {
    NewhandleAddUsers();
   }
  }, [alldata])
  

  return (
    <div
      onClick={(e) => {
        if (e.target.id === "modal1" || e.target.id === "modal2") {
          setModalOpen(false);
        }
      }}
    >
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
        id="modal1"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
        id="modal2"
      >
        <div
          ref={modalContent}
          className="bg-white overflow-auto max-w-3xl w-full max-h-full rounded shadow-lg flex flex-col"
        >
          <div class="py-4 px-4 ">
            <h3 class="mb-2 text-xl font-medium text-gray-900 flex justify-start">
              UPLOAD USERS IN BULK
            </h3>
            <span className="text-sm mb-2">
              To upload users in bulk, please download the template. Fill the
              details in the template and do not shift the columns. Note: If
              there are users with multiple teams, duplicate the row and change
              the team. Eg. for a user in 5 teams, his data will be filled in 5
              rows with the team names different and rest everything same. | For
              reference,
              <a
                href=""
                onMouseOver={() => {
                  setImg(true);
                }}
              >
                <b> click here</b>
              </a>
            </span>
            <br />
            <label
              htmlFor="myfile"
              className="btn flex-auto my-2 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white cursor-pointer"
            >
              <a href={template} download="Template">
                <span className={`fa-light fa-arrow-down-to-line mr-2`}></span>
                DOWNLOAD TEMPLATE
              </a>
            </label>
            <div>
              <StyledDropZone
                onDrop={(e) => importData(e)}
                children={"UPLOAD USERS FILE (EXCEL)"}
              />
            </div>
          </div>
        </div>
      </CssTransition>
      <ImageDataModal modalOpen={img} setModalOpen={setImg} />
    </div>
  );
}
